/* tslint:disable */
/* eslint-disable */
/**
 * Products API
 * API for managing products
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * What the branch registry declares for a branch, as the product form needs it.
 * @export
 * @interface BranchCapacitiesDto
 */
export interface BranchCapacitiesDto {
    /**
     * 
     * @type {string}
     * @memberof BranchCapacitiesDto
     */
    code: string;
    /**
     * 
     * @type {boolean}
     * @memberof BranchCapacitiesDto
     */
    hasTargetedSubscriber: boolean;
}

/**
 * Check if a given object implements the BranchCapacitiesDto interface.
 */
export function instanceOfBranchCapacitiesDto(value: object): value is BranchCapacitiesDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('hasTargetedSubscriber' in value) || value['hasTargetedSubscriber'] === undefined) return false;
    return true;
}

export function BranchCapacitiesDtoFromJSON(json: any): BranchCapacitiesDto {
    return BranchCapacitiesDtoFromJSONTyped(json, false);
}

export function BranchCapacitiesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BranchCapacitiesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'hasTargetedSubscriber': json['hasTargetedSubscriber'],
    };
}

export function BranchCapacitiesDtoToJSON(json: any): BranchCapacitiesDto {
    return BranchCapacitiesDtoToJSONTyped(json, false);
}

export function BranchCapacitiesDtoToJSONTyped(value?: BranchCapacitiesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'hasTargetedSubscriber': value['hasTargetedSubscriber'],
    };
}

